export enum Branch {
  joint = 1,
  senate = 2,
  house = 3
}
